import React from 'react'
import styled from 'styled-components'
import { Trans, useTranslation } from '~/i18n'
import getcdn from '~/modules/get_cdn_link'
import breakpoints from '../UI/breakpoints'
import SharedTitle from '../UI/SharedTitle'

const Partners = () => {
  const [t] = useTranslation()
  return (
    <Root>
      <SharedTitle style={{ fontWeight: 'normal' }} centered>
        <Trans i18nKey="Các Quỹ đối tác"></Trans>
      </SharedTitle>

      <Content>
        <PartnersImage src={getcdn('/images/home/partners-2.png')} alt="Our partners" />
        <PartnersImageMobile src={getcdn('/images/home/partners-mobile-2.png')} alt="Our partners" />
      </Content>
    </Root>
  )
}

export default Partners

//#region
const Root = styled.div`
  padding: 40px 20px;
  background-color: rgba(235, 243, 255, 0.4);
  ${breakpoints.md} {
    padding: 40px 80px;
  }
`

const Content = styled.div`
  background-color: white;
  border-radius: 24px;
  padding: 0;
  margin-top: 32px;

  ${breakpoints.md} {
    padding: 65px 75px;
  }
`

const PartnersImage = styled.img`
  display: none;

  ${breakpoints.md} {
    width: 100%;
    display: block;
  }
`

const PartnersImageMobile = styled.img`
  width: 100%;

  ${breakpoints.md} {
    display: none;
  }
`
//#endregion
